import React from 'react';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';

const alternative = (
    <FlatButton className="pointer w-800"
                labelStyle={{textTransform: 'none', fontWeight: 800, fontSize: '16px'}}
                labelPosition="before"
                icon={<i className="fa fa-caret-down ml-10"></i>}
                label='Lang. '>
    </FlatButton>
);


const IconMenus = () => (
    <IconMenu
        iconButtonElement={ alternative }
        anchorOrigin={{horizontal: 'left', vertical: 'top'}}
        targetOrigin={{horizontal: 'left', vertical: 'top'}}>
        <MenuItem primaryText="English" />
        <MenuItem primaryText="Arabic" />
    </IconMenu>
);

export default IconMenus;


// WEBPACK FOOTER //
// ./src/components/UI/IconMenu.js